import { render, staticRenderFns } from "./display-contact-relations.vue?vue&type=template&id=ce071d16&scoped=true&"
import script from "./display-contact-relations.ts?vue&type=script&lang=ts&"
export * from "./display-contact-relations.ts?vue&type=script&lang=ts&"
import style0 from "./display-contact-relations.scss?vue&type=style&index=0&id=ce071d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce071d16",
  null
  
)

export default component.exports